import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import {
  RootStoreState,
  AuthStoreActions,
  AuthStoreSelectors,
  FeatureFlagStoreSelectors,
} from '@surface-elements/shared/data-access';
import { SharedUiSearchModule } from '@surface-elements/shared/ui-search';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  imports: [RouterModule, NgbModule, SharedUiSearchModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarComponent {
  private store = inject<Store<RootStoreState.State>>(Store);

  private readonly authState = this.store.selectSignal(
    AuthStoreSelectors.getAuthFeatureState,
  );
  readonly isAuthenticated = computed(() => this.authState().isAuthenticated);
  readonly user = computed(() => this.authState().user);

  readonly showProfileMenu = this.store.selectSignal(
    FeatureFlagStoreSelectors.selectFlag('userProfileMenu'),
  );
  private readonly featureFlagAdminEnabled = this.store.selectSignal(
    FeatureFlagStoreSelectors.selectFlag('featureFlagAdmin'),
  );
  readonly showAdminItems = computed(
    () =>
      this.featureFlagAdminEnabled() &&
      (this.user()?.roles?.includes('SENDSERV_ADMIN') ?? false),
  );

  // Plain field: toggled only by template click events, which mark the OnPush
  // view dirty on their own — no signal needed.
  isMenuCollapsed = true;

  logOut(): void {
    this.store.dispatch(AuthStoreActions.logOut());
  }
}
